export const type = 'alert.externalRecipients';
